import { useGenericAPI, useSingleGenericAPI } from '../../../utils/genericAPI/useGenericAPI'
import { ChangePasswordRequest, ChangePasswordRequestPatch } from '../types/user.types'
import { BASE_USER_RESET_PASSWORD_REQUEST } from '../services/user.api'

export default function useSingleResetPasswordRequest(requestId?: string) {

  const requestIdFound = requestId 

  const {singleQuery} = useSingleGenericAPI<ChangePasswordRequest, ChangePasswordRequestPatch>({
    baseURL: BASE_USER_RESET_PASSWORD_REQUEST,
    APIname: "user-reset-password-request",
    id: requestIdFound,
    disableGet: !requestIdFound,
  })

  return {
    singleResetPasswordRequestQuery: singleQuery,
    requestId : requestIdFound,
  }
}

export const useResetPasswordRequest = () => {
  const {createNew} = useGenericAPI<ChangePasswordRequest, ChangePasswordRequestPatch, ChangePasswordRequestPatch>({
    baseURL: BASE_USER_RESET_PASSWORD_REQUEST,
    APIname: "user-reset-password-request",
    pageSize: 10,
    orderBy: "rpr_created_at",
  })

  return {
    createNewResetPasswordRequest: createNew
  }
  
}